var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconModerationRequest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "writing 1",
    clipPath: "url(#clip0_14595_30652)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.2647 7.85989C20.7832 7.37807 20.0178 7.34779 19.5003 7.76953C19.4254 7.83053 19.4834 7.77678 18.3438 8.91642L21.302 11.8747L22.3651 10.8248C22.8792 10.3108 22.8792 9.47439 22.3651 8.96032L21.2647 7.85989Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.2766 15.0386L10.5365 18.7676C10.4193 19.0188 10.4717 19.3164 10.6677 19.5124C10.8637 19.7085 11.1615 19.7609 11.4126 19.6437L15.1415 17.9035C15.289 17.8346 14.8424 18.2526 20.3632 12.8008L17.4108 9.84839C11.937 15.3222 12.3468 14.8882 12.2766 15.0386Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.2525 18.7136C16.0911 18.873 15.905 19.0024 15.6995 19.0983L11.9705 20.8385C11.2373 21.1807 10.3414 21.0504 9.736 20.4448C9.15017 19.859 8.99192 18.961 9.34225 18.2102L11.0824 14.4812C11.1802 14.2718 11.3126 14.0827 11.4761 13.9192L17.082 8.31325V2.72754C17.082 1.63712 16.1949 0.75 15.1045 0.75H2.22852C1.1381 0.75 0.250977 1.63712 0.250977 2.72754V21.2725C0.250977 22.3629 1.1381 23.25 2.22852 23.25H15.1045C16.1949 23.25 17.082 22.3629 17.082 21.2725V17.8943L16.2525 18.7136ZM3.76665 5.0127H13.6104C13.9744 5.0127 14.2696 5.30783 14.2696 5.67188C14.2696 6.03592 13.9744 6.33105 13.6104 6.33105H3.76665C3.4026 6.33105 3.10747 6.03592 3.10747 5.67188C3.10747 5.30783 3.4026 5.0127 3.76665 5.0127ZM3.76665 8.52832H11.501C11.8651 8.52832 12.1602 8.82346 12.1602 9.1875C12.1602 9.55154 11.8651 9.84668 11.501 9.84668H3.76665C3.4026 9.84668 3.10747 9.55154 3.10747 9.1875C3.10747 8.82346 3.4026 8.52832 3.76665 8.52832ZM3.10747 12.7031C3.10747 12.3391 3.4026 12.0439 3.76665 12.0439H9.39165C9.75569 12.0439 10.0508 12.3391 10.0508 12.7031C10.0508 13.0672 9.75569 13.3623 9.39165 13.3623H3.76665C3.4026 13.3623 3.10747 13.0672 3.10747 12.7031Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14595_30652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.5,
    height: 22.5,
    fill: "white",
    transform: "translate(0.25 0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModerationRequest);
export default __webpack_public_path__ + "static/media/icon-moderation-request.53b852503af31732c10984cafeac5292.svg";
export { ForwardRef as ReactComponent };